import React from 'react';

import { CopyContent as NewCopyContent } from '@/ui/CopyContent/CopyContent';

import { CopyContentProps } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 * Note: the new component always renders the copy icon after the content — `iconPosition="left"`
 * callers will see the icon on the right now.
 */
const CopyContent: React.FC<CopyContentProps> = ({
  content,
  copyButtonClassName,
  children,
  wrapperClassName,
  iconTimeout,
  testId
}) => (
  <NewCopyContent
    content={content}
    iconTimeout={iconTimeout}
    className={wrapperClassName}
    buttonClassName={copyButtonClassName}
    data-testid={testId}>
    {children}
  </NewCopyContent>
);

export default CopyContent;
